import React, { useState, useEffect, useCallback } from 'react';
import { makeStyles } from 'react-scale/components/design-system';
import { Button } from 'design-system/Button';
import Markdown from '@scale/frontend-lib/markdown';

interface WebsiteAttachmentProps {
  startingUrl: string;
  instruction?: string;
  onOpenWebsite?: () => void;
}

const Website: React.FC<WebsiteAttachmentProps> = ({ startingUrl, instruction, onOpenWebsite }) => {
  const styles = useStyles();

  const normalizeUrl = useCallback(
    (url: any, defaultHttps = false) => {
      let normalizedUrl = url;
      if (startingUrl.indexOf('http://') === 0 && defaultHttps) {
        normalizedUrl = url.replace('http://', 'https://');
      }

      if (startingUrl.indexOf('http://') === -1 && startingUrl.indexOf('https://') === -1) {
        normalizedUrl = defaultHttps ? `https://${normalizedUrl}` : `http://${normalizedUrl}`;
      }

      return normalizedUrl;
    },
    [startingUrl],
  );

  const [openInNewTabUrl, setOpenInNewTabUrl] = useState<string>(normalizeUrl(startingUrl, false));

  useEffect(() => {
    setOpenInNewTabUrl(normalizeUrl(startingUrl, false));
  }, [startingUrl, normalizeUrl]);

  const openInNewTab = () => {
    window.open(openInNewTabUrl, '_blank');
    if (onOpenWebsite) {
      onOpenWebsite();
    }
  };

  return (
    <div className={styles.attachmentWebsite}>
      <div className={styles.websiteToolbar}>
        <Button onClick={openInNewTab}>Open in new tab</Button>
      </div>

      {instruction && (
        <div className={styles.websiteInstruction}>
          <br />
          <div className={styles.divider} />
          <br />
          <h1>Instruction</h1>
          <div
            className={styles.instructionsMarkdown}
            dangerouslySetInnerHTML={{ __html: Markdown.render(instruction) }}
          />
        </div>
      )}
    </div>
  );
};

const useStyles = makeStyles({
  attachmentWebsite: {
    flex: '0 0 100%',
    height: '70vh',
  },
  websiteToolbar: {
    display: 'flex',
    width: '100%',
    marginBottom: '20px',
  },
  websiteInstruction: {
    width: '100%',
    height: '100%',
  },
  instructionsMarkdown: {
    '& iframe': {
      width: '100%',
      height: '100%',
      minHeight: '700px',
    },
  },
  divider: {
    margin: '12px 0',
    borderTop: '3px solid gray',
  },
});

export default Website;
